import CreatorShell from "@/components/creator/CreatorShell";
import UploadCard from "@/components/enhance/UploadCard";
import EnhanceHistory from "@/components/enhance/EnhanceHistory";

const HOW = [
  ["A", "Original", "Exactly what you sang, only level-matched so the comparison is fair."],
  ["B", "Natural Voice", "Rumble and hiss gently removed. Your tone, accent and phrasing untouched."],
  ["C", "Studio-Polished", "Gentle tuning in your key, EQ, de-essing, compression, reverb, echo and optional doubling."],
];

/** `/create/enhance` — upload a vocal and see every vocal you've enhanced. */
export default function EnhancePage() {
  return (
    <CreatorShell testId="enhance-page" back="/create" title="Enhance My Vocals" subtitle="Upload a vocal and hear it three ways: Original, Natural Voice and Studio-Polished.">
      <div className="grid gap-6 lg:grid-cols-[1.15fr_1fr]">
        <UploadCard />
        <div className="space-y-6">
          <section className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/60 p-5 sm:p-7">
            <h2 className="font-display text-base font-semibold md:text-lg">You get three versions</h2>
            <ul className="mt-4 space-y-4">
              {HOW.map(([k, t, b]) => (
                <li key={k} className="flex gap-3">
                  <span className="grid h-7 w-7 flex-shrink-0 place-items-center rounded-lg bg-white/10 font-mono text-[12px] font-bold">{k}</span>
                  <span><span className="block text-[14px] font-medium">{t}</span><span className="block text-[12px] leading-relaxed text-white/50">{b}</span></span>
                </li>
              ))}
            </ul>
            <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.16em] text-white/35">All 24-bit · 48 kHz · same loudness · same start time</p>
          </section>
          <EnhanceHistory />
        </div>
      </div>
    </CreatorShell>
  );
}
